module.exports = __webpack_public_path__ + "static/media/header4.1c2fe1f7.png";